module.exports = __webpack_public_path__ + "static/media/greys.46799147.jpg";